import { useEffect, useCallback } from 'react';

/**
 * Hook to handle page and interaction tracking.
 * @param {Object} options - Configuration options.
 * @param {string} options.pageName - Name of the page for tracking.
 * @param {Function} options.trackInteraction - Tracking function from props/HOC.
 * @returns {Object} Tracking handlers.
 */
const usePageTracking = ({ pageName, trackInteraction }) => {
  useEffect(() => {
    if (trackInteraction && pageName) {
      trackInteraction({
        action: "PAGE_VIEW",
        page: pageName,
      });
    }
  }, [pageName, trackInteraction]);

  const handleInteraction = useCallback((element, action = "CLICK") => {
    if (trackInteraction && pageName) {
      trackInteraction({
        action,
        page: pageName,
        element,
      });
    }
  }, [pageName, trackInteraction]);

  return {
    handleInteraction
  };
};

export default usePageTracking;
